import * as React from 'react';
import { Navigate } from 'react-router-dom';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import AuthService from '../services/auth.js';
import "../Amenities.css"

import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PaymentsIcon from '@mui/icons-material/Payments';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import Divider from '@mui/material/Divider';
import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';

import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';

import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { alpha } from '@mui/material/styles';

// import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import dayjs from 'dayjs';
import Drawer from '@mui/material/Drawer';

import apiClient, { shouldRedirectToLogin, getErrorMessage } from '../services/api-client';
import AppConfig from '../services/app-config.js';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export default function Home({setNavbarState, navbarState, window}) {
  const [redirect, setRedirect] = React.useState({ trigger: false, route: '/' });
  const [loading, setLoading] = React.useState(true);
  const [amenity, setAmenity] = React.useState({});
  const [amenityReservations,setAmenityReservations] = React.useState({});
  const [reservation,setReservation] = React.useState({});
  const [drawerShow, setDrawerShow] = React.useState(false);
  const [showBackdrop, setShowBackdrop] = React.useState(false);
  const [date,setDate] = React.useState(dayjs());
  const [timeRanges, setTimeRanges] = React.useState({});
  const [deleteDialog,setDeleteDialog] = React.useState(false);
  const [snackbar, setSnackbar] = React.useState({ open: false, message: '', severity: 'success' });
  const [refresh,setRefresh] = React.useState(false);

  const reservationId = new URLSearchParams(location.search).get('id');
  let snackbarmsg = new URLSearchParams(location.search).get('msg');
  let snackbarlvl = new URLSearchParams(location.search).get('lvl',"success");
  const amenityId = reservationId.split('-')[0];
  const apiUrl = process.env.REACT_APP_MGO_API_URL;

  const weekDays = ["Lunes","Martes","Miercoles","Jueves","Viernes","Sabado","Domingo"]
  const monthsSpa = ["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octobre","Noviembre","Diciembre"]

  
  const closeReservationDialog = () => {
    setDeleteDialog(false);
  }

  const triggerRefresh = () => {
    setRefresh(!refresh);
  }

  const deleteReservation = () => {
    setLoading(true);
    setShowBackdrop(true);
    setDeleteDialog(false);
    let resDate = dayjs.unix(reservationId.split('-')[1]).format('DDMMYY');
    apiClient.post('reservation/delete', {dia: resDate, reservacion: reservationId}, {}, { action: 'delete_reservation' })
      .then(response => {
        if (response.status === 200) {
          setRedirect({ trigger: true, route: `/amenidades?msg=Reservacion eliminada exitosamente&lvl=success` });
        } else if (response.status === 422) {
          setSnackbar({ open: true, message: response.data.data.mensaje, severity: 'error' });
        }
        setLoading(false);
        setShowBackdrop(false);
      })
      .catch(error => {
        if(error.response && error.response.data && error.response.data.code === 422) {
          setSnackbar({ open: true, message: error.response.data.data.mensaje, severity: 'error' });
        }
        else  {
        console.error('Error deleting reservation:', error);
        setSnackbar({ open: true, message: "Hubo un error al intentar eliminar la reservacion porfavor intenta de nuevo mas tarde.", severity: 'error' })};
        setLoading(false);
        setShowBackdrop(false);
      });
  }

  const deleteReservationPre = () => {
    setDeleteDialog(true);
  }

  const handleDrawerToggle = () => {
    setDrawerShow(!drawerShow);
  }

  function convertEpochsToTimeString(epoch1, epoch2) {
    const date1 = new Date(epoch1 * 1000);
    const date2 = new Date(epoch2 * 1000);

    const day = date1.getDate();
    const month = date1.toLocaleString('default', { month: 'short' });
    const time1 = date1.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    const time2 = date2.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

    return `${day}/${month} ${time1} - ${time2}`;
  }

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar({ ...snackbar, open: false });
  };

  const ceil = (option, dayjsClass) => {
    dayjsClass.prototype.ceil = function (unit, amount) {
        return this.add(amount - (this.get(unit) % amount), unit).startOf(unit);
    };
  };
  dayjs.extend(ceil);

  const fetchReservations = (date) => {
    const formated_date = date.format('DDMMYY');
    apiClient.get(`amenity/reservations/${formated_date}/${amenityId}`, {}, { action: 'fetch_amenity_reservations' })
      .then(response => {
        if (response.status === 200) {
          const dataArray = Object.entries(response.data.data).map(([id, value]) => ({ id, ...value }));
          console.log(dataArray);
          if (response.data.data.hasOwnProperty(reservationId)) {
            setReservation(response.data.data[reservationId]);
          } else {
            setRedirect({ trigger: true, route: '/amenidades' });
            return
          }
          if (!AuthService.userRoleIncludes(["admin","receptor"]) && response.data.data[reservationId].usuario !== AuthService.getCurrentUserEmail()) {
            setRedirect({ trigger: true, route: '/amenidades' });
            return
          }
          setAmenityReservations(dataArray);
          if (snackbarmsg !== null) {
            setSnackbar({ open: true, message: snackbarmsg, severity: snackbarlvl });
            setRedirect({ trigger: true, route: `/reservacion?id=${reservationId}` });
            snackbarmsg = null;
          }
          setShowBackdrop(false);
          setLoading(false);  
        }
      })
      .catch(error => {
        console.error('Error fetching reservations:', error);
        setSnackbar({ open: true, message: 'Hubo un error obteniendo las reservaciones de la amenidad', severity: 'error' });
        setShowBackdrop(false);
          setLoading(false);  
      });
  }

  const fetchInfo = (date,id) => {

    const dayOfWeek = date.day() || 7;
    apiClient.get(`amenity/${id}`, {}, { action: 'fetch_amenity' })
      .then(response => {
        if (response.status === 200) {
          let disponible_hoy = false;
          let inicio = date;
          let inicio_uf = "00:00";
          let fin = date;
          let fin_uf = "23:59";
          let amenityTemp = response.data.data;
          amenityTemp.dia_de_semana = weekDays[dayOfWeek-1]
          amenityTemp.mes = monthsSpa[date.month()];
          amenityTemp.showBlock = false;
          let timeRangesTemp = {"from": {"min":date,"max":date,"value":date}, "to": {"min":date,"max":date,"value": date}}
          for (const horario of response.data.data.horarios) {
            if (horario.dias.includes(dayOfWeek)) {
              disponible_hoy = true;
              inicio_uf = horario.hora_inicio;
              fin_uf = horario.hora_fin;
              inicio = date.set('hour', parseInt(horario.hora_inicio.split(':')[0])).set('minute', parseInt(horario.hora_inicio.split(':')[1])).set('second', 0);
              fin = date.set('hour', parseInt(horario.hora_fin.split(':')[0])).set('minute', parseInt(horario.hora_fin.split(':')[1])).set('second', 0);
              timeRangesTemp = {"from": {"min":inicio,"max":fin.subtract(amenityTemp.reservacion.tiempo_minimo-1,"minutes"),"value": inicio}, "to": {"min":inicio.add(amenityTemp.reservacion.tiempo_minimo - 1, "minutes"),"max":fin,"value":inicio.add(amenityTemp.reservacion.tiempo_minimo*2,"minutes")}};
              break;
            }
          }
          if (disponible_hoy && amenityTemp.bloquear) {
            if (dayjs.unix(amenityTemp.bloquear.fecha_fin).isAfter(inicio)) {
              amenityTemp.showBlock = true;
            }
          }
          setTimeRanges(timeRangesTemp);
          setAmenity({"disponible_hoy": disponible_hoy, "horario_hoy": {"inicio": inicio,"fin": fin, "inicio_uf":inicio_uf, "fin_uf": fin_uf},...response.data.data});
          fetchReservations(date);     
        }
      })
      .catch(error => {
        console.error('Error fetching amenities:', error);
        setSnackbar({ open: true, message: 'Hubo un error obteniendo los detalles de la amenidad', severity: 'error' });
        setLoading(false);
        setShowBackdrop(false);
      });
  }

  const fabStyle = {
    position: 'fixed',
    bottom: 32,
    right: 32
  };

  const reservationDrawer = (
    <Card
    sx={{
      py: 3,
      px: 2,
      display: 'block',
      marginLeft: 'auto',
      marginRight: 'auto',
      borderTopLeftRadius: "20px",
      borderTopRightRadius: "20px",
      borderBottomRightRadius: "0px",
      borderBottomLeftRadius: "0px",
      maxWidth: "550px",
      width: "100%",
      backgroundColor: (theme) => theme.palette.background.paper,
    }}>
        
      <CardContent>
      </CardContent>
      <CardActions>
        <Button size="medium" color="inherit" variant="outlined" onClick={handleDrawerToggle}>Cancelar</Button>
        <Button size="medium" color="secondary" variant="contained" onClick={() => deleteReservationPre()} disabled={amenity.conflicto} >Reservar</Button>
      </CardActions>
    </Card>
  );
    

  React.useEffect(() => {
    setNavbarState({ ...navbarState, showBack: false, showOptions: false, showSearch: false})
    if (reservationId === null) {
      setRedirect({ trigger: true, route: '/amenidades' });
    }
    let resDate = dayjs.unix(reservationId.split('-')[1]);
    setShowBackdrop(true);
    setLoading(true);
    fetchInfo(resDate,amenityId);
  }, [date,refresh]);

const container = window !== undefined ? () => window().document.body : undefined;

const formatReservationDate = (epoch) => {
  const d = new Date(epoch * 1000);
  return `${d.getDate()} ${monthsSpa[d.getMonth()]}, ${d.getFullYear()}`;
};

return (
    <>
    <Container maxWidth="sm">
      {redirect.trigger && (
        <Navigate to={redirect.route} replace={true} />
      )}
    <Snackbar open={snackbar.open} autoHideDuration={8000} anchorOrigin={{ vertical: "top", horizontal: "center" }} sx={{mt: "3.2rem"}} onClose={handleSnackbarClose}>
      <Alert onClose={handleSnackbarClose} severity={snackbar.severity}>
        {snackbar.message}
      </Alert>
    </Snackbar>
    <Box sx={{ mt: 0 }}>
      <Backdrop open={showBackdrop} sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, color: '#fff' }}>
        <CircularProgress color="inherit" />
      </Backdrop>
        {!loading && (
          <>
          {/* Hero image with overlay */}
          <Box
            sx={{
              position: 'relative',
              overflow: 'hidden',
              mb: -0.5,
              borderBottomLeftRadius: '24px',
              borderBottomRightRadius: '24px'
            }}
          >
            <img
              src={`${apiUrl}/img/amenities/${amenityId}.jpg`}
              alt="Amenity"
              onError={(e) => { e.target.src = '/amenityplaceholder.png'; }}
              style={{ width: '100%', display: 'block', maxHeight: '220px', objectFit: 'cover' }}
            />
            <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'linear-gradient(to top, rgba(0,0,0,0.6) 0%, transparent 60%)' }} />
            <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, px: 2, pt: { xs: 2, sm: 2.5 }, pb: 1.5 }}>
              <IconButton onClick={() => setRedirect({ trigger: true, route: '/amenidades' })} sx={{ color: '#fff', '&:hover': { backgroundColor: 'rgba(255,255,255,0.15)' } }} size="small">
                <ArrowBackIcon fontSize="small" />
              </IconButton>
            </Box>
            <Box sx={{ position: 'absolute', bottom: 0, left: 0, right: 0, p: 2 }}>
              <Typography variant="h5" sx={{ color: '#fff', fontWeight: 700 }}>
                {amenity.nombre}
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.3 }}>
                <LocationOnIcon sx={{ fontSize: 14, color: 'rgba(255,255,255,0.8)' }} />
                <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.8)' }}>
                  {amenity.area || 'Área Común'}
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* Content card */}
          <Card variant="outlined" sx={{ borderRadius: '0 0 16px 16px', border: 'none', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
            <CardContent sx={{ px: 2.5, pt: 2.5 }}>
              {/* Date + Status */}
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Box>
                  <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase', fontWeight: 600, letterSpacing: 0.5, fontSize: '0.65rem' }}>
                    Fecha
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 700 }}>
                    {formatReservationDate(reservation.inicio)}
                  </Typography>
                </Box>
                <Chip
                  label={reservation.confirmada ? 'Confirmada' : (reservation.fin > dayjs().unix() ? 'Pendiente' : 'Pasada')}
                  size="small"
                  sx={{
                    fontWeight: 700, fontSize: '0.7rem', borderRadius: 1,
                    backgroundColor: (theme) => {
                      if (reservation.confirmada) {
                        return alpha(theme.palette.success.main, theme.palette.mode === 'dark' ? 0.28 : 0.14);
                      }
                      if (reservation.fin > dayjs().unix()) {
                        return alpha(theme.palette.warning.main, theme.palette.mode === 'dark' ? 0.28 : 0.14);
                      }
                      return alpha(theme.palette.text.primary, theme.palette.mode === 'dark' ? 0.14 : 0.06);
                    },
                    color: (theme) => {
                      if (reservation.confirmada) {
                        return theme.palette.success.main;
                      }
                      if (reservation.fin > dayjs().unix()) {
                        return theme.palette.warning.main;
                      }
                      return theme.palette.text.secondary;
                    },
                  }}
                />
              </Box>

              {/* Time + Info grid */}
              <Box sx={{ display: 'flex', gap: 3, mb: 2 }}>
                <Box>
                  <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase', fontWeight: 600, letterSpacing: 0.5, fontSize: '0.65rem' }}>
                    Horario
                  </Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <AccessTimeIcon sx={{ fontSize: 14, color: 'text.secondary' }} />
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                      {AppConfig.formatHour(reservation.inicio)} - {AppConfig.formatHour(reservation.fin)}
                    </Typography>
                  </Box>
                </Box>
              </Box>

              {/* Status info for regular users */}
              {!AuthService.userRoleIncludes(["admin","receptor"]) ? (
                <Box sx={{ mb: 2 }}>
                  {reservation.confirmada ? (
                    <Box sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 0.5,
                      p: 1.5,
                      backgroundColor: (theme) => alpha(theme.palette.success.main, theme.palette.mode === 'dark' ? 0.28 : 0.14),
                      borderRadius: 2
                    }}>
                      <CheckCircleIcon sx={{ fontSize: 18, color: (theme) => theme.palette.success.main }} />
                      <Typography variant="body2" sx={{ color: (theme) => theme.palette.success.main, fontWeight: 500 }}>
                        Tu reservación está confirmada.
                      </Typography>
                    </Box>
                  ) : reservation.fin > dayjs().unix() ? (
                    <Box>
                      <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.5,
                        p: 1.5,
                        backgroundColor: (theme) => alpha(theme.palette.warning.main, theme.palette.mode === 'dark' ? 0.28 : 0.14),
                        borderRadius: 2,
                        mb: 1
                      }}>
                        <CancelIcon sx={{ fontSize: 18, color: (theme) => theme.palette.warning.main }} />
                        <Typography variant="body2" sx={{ color: (theme) => theme.palette.warning.main, fontWeight: 500 }}>
                          Pendiente de confirmación por administración.
                        </Typography>
                      </Box>
                      {amenity.reservacion.monto_pago > 0 && (
                        <Box sx={{
                          p: 1.5,
                          backgroundColor: (theme) => alpha(theme.palette.text.primary, theme.palette.mode === 'dark' ? 0.14 : 0.06),
                          borderRadius: 2
                        }}>
                          <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.3 }}>
                            Monto a pagar: Q. {amenity.reservacion.monto_pago.toFixed(2)}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            <PaymentsIcon sx={{ fontSize: 12, verticalAlign: 'middle', mr: 0.3 }} />
                            Notifica tu pago a administración para agilizar la confirmación.
                          </Typography>
                        </Box>
                      )}
                    </Box>
                  ) : null}
                </Box>
              ) : (
                <Box sx={{ mb: 2 }}>
                  {!reservation.confirmada && reservation.fin > dayjs().unix() && (
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
                      <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
                        Pendiente de Confirmar
                      </Typography>
                      {AuthService.userRoleIncludes(["admin"]) && (
                        <Button
                          color="secondary" variant="outlined" size="small"
                          onClick={() => setRedirect({ trigger: true, route: '/aprobaciones' })}
                          endIcon={<ArrowForwardIcon sx={{ fontSize: 14 }} />}
                          sx={{ textTransform: 'none', fontSize: '0.75rem', borderRadius: 2 }}
                        >
                          Ir a Aprobaciones
                        </Button>
                      )}
                    </Box>
                  )}
                  <Divider sx={{ mb: 1 }} />
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                      {reservation.residente}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {reservation.unidad}
                    </Typography>
                  </Box>
                </Box>
              )}

              {/* Day's agenda timeline */}
              <Divider sx={{ mb: 1.5 }} />
              <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
                Agenda del Día
              </Typography>
              <Timeline position="left" sx={{ p: 0, m: 0, maxHeight: '25vh', overflow: 'auto' }}>
                <TimelineItem key="starting-time" sx={{ minHeight: 40 }}>
                  <TimelineOppositeContent sx={{ flex: 0.3, py: 0.3, fontSize: '0.75rem' }} color="text.secondary">
                    {amenity.horario_hoy.inicio_uf}
                  </TimelineOppositeContent>
                  <TimelineSeparator>
                    <TimelineDot color="success" sx={{ my: 0.3, width: 8, height: 8, p: 0 }} />
                    <TimelineConnector sx={{ minHeight: 15 }} />
                  </TimelineSeparator>
                  <TimelineContent sx={{ py: 0.3, fontSize: '0.8rem' }}>Disponible</TimelineContent>
                </TimelineItem>
                {amenityReservations.map((res, index) => (
                  <TimelineItem key={res.id} sx={{ minHeight: 40 }}>
                    <TimelineOppositeContent sx={{ flex: 0.3, py: 0.3, fontSize: '0.75rem' }} color="text.secondary">
                      {AppConfig.formatHour(res.inicio)}
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                      <TimelineDot
                        color={res.usuario === AuthService.getCurrentUserEmail() ? "success" : "warning"}
                        variant={res.usuario === AuthService.getCurrentUserEmail() ? "filled" : "outlined"}
                        sx={{ my: 0.3, width: 8, height: 8, p: 0 }}
                      />
                      <TimelineConnector sx={{ minHeight: 15 }} />
                    </TimelineSeparator>
                    <TimelineContent sx={{ py: 0.3 }}>
                      <Typography variant="body2" sx={{ fontSize: '0.8rem', fontWeight: res.usuario === AuthService.getCurrentUserEmail() ? 600 : 400 }}>
                        {res.usuario === AuthService.getCurrentUserEmail() ? 'Tu Reservación' : 'Reservado'}
                      </Typography>
                      {res.fin > dayjs().unix() && (
                        <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.65rem' }}>
                          {res.confirmada ? 'Confirmada' : 'Pendiente'}
                        </Typography>
                      )}
                    </TimelineContent>
                  </TimelineItem>
                ))}
                <TimelineItem key="finishing-time" sx={{ minHeight: 40 }}>
                  <TimelineOppositeContent sx={{ flex: 0.3, py: 0.3, fontSize: '0.75rem' }} color="text.secondary">
                    {amenity.horario_hoy.fin_uf}
                  </TimelineOppositeContent>
                  <TimelineSeparator>
                    <TimelineDot sx={{ my: 0.3, width: 8, height: 8, p: 0 }} />
                  </TimelineSeparator>
                  <TimelineContent sx={{ py: 0.3, fontSize: '0.8rem' }}>Cerrado</TimelineContent>
                </TimelineItem>
              </Timeline>

              {/* Rules section */}
              {!AuthService.userRoleIncludes(["admin","receptor"]) && amenity.obs && amenity.obs.length > 0 && (
                <>
                  <Divider sx={{ mt: 1.5, mb: 1.5 }} />
                  <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
                    Reglas de la Amenidad
                  </Typography>
                  {amenity.obs.map((nota, index) => (
                    <Box key={`nota-${index}`} sx={{ display: 'flex', gap: 1, mb: 1, alignItems: 'flex-start' }}>
                      <InfoOutlinedIcon sx={{ fontSize: 16, color: 'text.disabled', mt: 0.2 }} />
                      <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.5 }}>
                        {nota}
                      </Typography>
                    </Box>
                  ))}
                </>
              )}
            </CardContent>

            {/* Cancel button */}
            {reservation.fin > dayjs().unix() && (
              <CardActions sx={{ px: 2.5, pb: 2.5, pt: 0 }}>
                <Button
                  fullWidth variant="contained"
                  onClick={() => deleteReservationPre()}
                  sx={{
                    backgroundColor: (theme) => theme.palette.error.main, borderRadius: 2,
                    textTransform: 'none', fontWeight: 600, py: 1.2,
                    '&:hover': { backgroundColor: (theme) => theme.palette.error.dark }
                  }}
                >
                  Cancelar Reservación
                </Button>
              </CardActions>
            )}
          </Card>
          </>)}
    </Box>
    {!loading && (
    <>
    <Drawer
          container={container}
          anchor="bottom"
          variant="temporary"
          open={drawerShow}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          PaperProps={{ elevation: 0, style: { backgroundColor: "transparent" } }}
          sx={{
            display: { xs: 'block' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: '440' },
          }}
        >
          {reservationDrawer}
    </Drawer>
    <Dialog open={deleteDialog} onClose={closeReservationDialog}>
        <DialogTitle>Cancelar Reserva</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {deleteDialog ? <Typography>¿Está seguro que desea cancelar esta reservacion?</Typography> : ''}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeReservationDialog} color="secondary">
            No Cancelar
          </Button>
          <Button onClick={() => deleteReservation()} color="primary">
            Cancelar
          </Button>
        </DialogActions>
    </Dialog>
    </>
    )}
      
    </Container>
  </>);
}